import { useEffect } from "react";
import { toast } from "sonner";

const current = () => document.querySelector("script[src*='/static/js/main.']")?.getAttribute("src");

// Tells open tabs when a newer build has been published so nobody keeps working on stale code.
export function VersionWatch() {
  useEffect(() => {
    const mine = current();
    if (!mine) return undefined;
    let shown = false;
    const check = async () => {
      if (shown || document.hidden) return;
      try {
        const html = await (await fetch(`/?v=${Date.now()}`, { cache: "no-store" })).text();
        const live = html.match(/\/static\/js\/main\.[a-z0-9]+\.js/)?.[0];
        if (live && !mine.endsWith(live)) {
          shown = true;
          toast("A new version of the app is live", { duration: Infinity, action: { label: "Reload", onClick: () => window.location.reload() } });
        }
      } catch { /* offline */ }
    };
    const t = setInterval(check, 120000);
    document.addEventListener("visibilitychange", check);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", check); };
  }, []);
  return null;
}
